import type { ThemeDetail, EntityDetail } from './api';

/** Déclenche le téléchargement d'un fichier Markdown côté navigateur. */
export function downloadMarkdown(filename: string, content: string): void {
  const blob = new Blob([content], { type: 'text/markdown;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.replace(/[^\p{L}\p{N}_-]+/gu, '-').replace(/-+/g, '-') + '.md';
  a.click();
  URL.revokeObjectURL(url);
}

const list = (items: string[]) => (items.length ? items.map((i) => `- ${i}`).join('\n') : '_(aucun)_');

/** Markdown d'une fiche thème : grains + entités + thèmes liés. */
export function themeMarkdown(d: ThemeDetail): string {
  return [
    `# Thème · ${d.theme.label}`,
    '',
    `> Export Gnosis — ${d.grains.length} grain(s), ${d.entities.length} entité(s) liée(s).`,
    '',
    '## Entités liées',
    list(d.entities.map((e) => `**${e.name}** (${e.type} · ${e.ownership}) — ${e.n} grain(s)`)),
    '',
    '## Thèmes proches',
    list(d.relatedThemes.map((t) => `${t.label} (${t.n})`)),
    '',
    '## Grains',
    d.grains.map((g) => `### ${g.title}\n\n${g.excerpt}`).join('\n\n'),
    '',
  ].join('\n');
}

/** Markdown d'une fiche entité : synthèse (si présente) + grains + liens. */
export function entityMarkdown(d: EntityDetail): string {
  return [
    `# ${d.entity.name}`,
    '',
    `> ${d.entity.type} · responsabilité : ${d.entity.ownership} — export Gnosis (${d.grains.length} grain(s)).`,
    '',
    ...(d.entity.sheet ? ['## Synthèse', d.entity.sheet, ''] : []),
    '## Thèmes',
    list(d.themes.map((t) => `${t.label} (${t.n})`)),
    '',
    '## Entités liées',
    list(d.relatedEntities.map((e) => `**${e.name}** (${e.type} · ${e.ownership}) — ${e.n}`)),
    '',
    '## Grains',
    d.grains.map((g) => `### ${g.title}\n\n${g.excerpt}`).join('\n\n'),
    '',
  ].join('\n');
}
